export default __webpack_public_path__ + "static/media/mobiledemand.a79b7674.png";